import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { usePageTitle } from 'app/hooks';
import { fetchVacancies } from 'features/vacancies/vacanciesSlice';
import { formatDate, getApplyBaseUrl } from 'utils/index';

import styles from './styles.module.scss';

export default function Vacancies() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { items, loading, error } = useAppSelector((state) => state.vacancies);

  const [copiedId, setCopiedId] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<'active' | 'archived'>('active');

  usePageTitle('Вакансии');

  useEffect(() => {
    dispatch(fetchVacancies());
  }, [dispatch]);

  const handleRowClick = (id: number) => {
    navigate(`/vacancies/${id}`);
  };

  const handleCopy = async (id: number, slug: string) => {
    const url = `${getApplyBaseUrl()}/apply/${slug}`;
    try {
      await navigator.clipboard.writeText(url);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 5000);
    } catch (err) {
      console.error('Не удалось скопировать ссылку', err);
    }
  };

  const filteredVacancies = [...items]
    .sort((a, b) =>
      new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime()
    )
    .filter((v) => (activeTab === 'active' ? v.is_active : !v.is_active));

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Ваши вакансии</h2>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'active' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('active')}
        >
          Активные
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'archived' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('archived')}
        >
          Архив
        </button>
      </div>

      {loading && <p>Загрузка...</p>}
      {error && <p className={styles.error}>{error}</p>}

      {filteredVacancies.length === 0 ? (
        <p className={styles.empty}>Нет вакансий</p>
      ) : (
        <div className={styles.vacanciesList}>
            {filteredVacancies.map((vacancy) => (
              <div className={styles.vacancyItem} key={vacancy.id}>
                <div>
                  <div className={styles.vacancyHeader}>
                    <div className={styles.applicationsTotal}><GroupIcon />&nbsp;{vacancy.applications_total}</div>
                    <div className={styles.date}>{formatDate(vacancy.created_at || '')}</div>
                  </div>
                  <h3>{vacancy.title}</h3>
                  <div className={styles.grade}>{vacancy.grade}</div>
                </div>
                <div className={styles.btnWrapper}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCopy(vacancy.id, vacancy.apply_slug || '');
                    }}
                    className={`${styles.copyBtn} ${copiedId === vacancy.id ? styles.copiedBtn : ''}`}
                  >
                    {copiedId === vacancy.id ? 'Ссылка скопирована' : 'Скопировать ссылку'}
                  </button>
                  <button className={styles.openBtn} onClick={() => handleRowClick(vacancy.id)}>Открыть</button>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
